var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#691B33",
    d: "m20.624 4.02-.64-.64c-.38-.38-.88-.58-1.4-.58-.54 0-1.02.2-1.4.58L4.544 16.04c-.08.08-.14.16-.18.28l-1.5 3.78c-.12.3-.04.64.18.86.16.16.36.24.56.24.1 0 .2-.02.3-.06l3.8-1.48c.1-.04.2-.1.28-.18l12.66-12.66c.76-.76.76-2.02-.02-2.8ZM5.764 17.14l1.12 1.12-1.86.72.74-1.84ZM19.484 5.7 8.444 16.74l-1.16-1.16 11.04-11.06c.1-.1.22-.12.28-.12.06 0 .18.02.28.12l.64.64c.12.14.12.38-.04.54Z"
  })));
};
export default SvgEdit;